module.exports = "/src/views/player/help/images/tatoo.jpg";